import React from "react";

export default () => {
  return (
    <>
      <p>
        <b>DECLARAÇÃO DE CIÊNCIA E CONCORDÂNCIA</b>
      </p>

      <p>Declaro que li e compreendi integralmente os seguintes documentos:</p>

      <ol style={{ listStyleType: "none" }}>
        <li>I. Termos e Condições de Uso;</li>
        <li>
          II. Cláusula de Mandato (Cláusula 8 dos Termos e Condições de Uso);
        </li>
      </ol>

      <p>
        E, por meio desta declaração, manifesto minha plena ciência e
        concordância com o conteúdo integral de cada um desses documentos.
      </p>

      <p>
        <b>I. TERMOS E CONDIÇÕES DE USO</b>
      </p>

      <h6>1. INTRODUÇÃO</h6>
      <p>
        1.1. Os presentes Termos e Condições de Uso (“Termos de Uso”)
        estabelecem os termos e condições que regem o acesso e a utilização da
        plataforma eletrônica ("Plataforma") disponibilizada pela MERCATÓRIO
        SECURITIZADORA E INVESTIMENTOS PARTICIPATIVOS EM CRÉDITOS JUDICIAIS S/A,
        sociedade anônima, inscrita no CNPJ sob o nº 53.834.001/0001-06, com
        sede na Avenida Raja Gabaglia, n. 2000, Bairro Alpes, CEP 30494-170,
        Belo Horizonte/MG ("MERCATÓRIO").
      </p>
      <p>
        1.2. A MERCATÓRIO, por meio da Plataforma (disponível em
        https://investimento.mercatorio.com.br/), tem como objetivo conectar
        investidores ("Usuário" ou "Investidor") interessados em adquirir
        títulos de dívida privada, representados por debêntures emitidas em
        operações estruturadas pela própria MERCATÓRIO. A atuação da MERCATÓRIO
        restringe-se à estruturação e distribuição das debêntures, bem como ao
        fornecimento de uma plataforma tecnológica que facilite o acesso a essas
        oportunidades de investimento pelos Investidores.
      </p>
      <p>
        1.2.1. A MERCATÓRIO não atua como instituição financeira, gestora de
        patrimônio, administradora ou distribuidora de valores mobiliários
        regulada pela CVM. As debêntures oferecidas por meio da Plataforma são
        títulos de dívida privada, não se enquadrando nas hipóteses de oferta
        pública de valores mobiliários conforme a Resolução CVM nº 160, de 13 de
        julho de 2022, ou em outras disposições regulatórias que estabeleçam
        registro prévio de oferta pública.
      </p>
      <p>
        1.3. Ao acessar e utilizar a Plataforma, o Usuário declara ter lido,
        compreendido e aceito integralmente os presentes Termos de Uso, bem como
        a Política de Privacidade da MERCATÓRIO, disponível no seguinte endereço
        eletrônico: https://www.mercatorio.com.br/politica-de-privacidade.
      </p>
      <span>
        1.4. Por meio da Plataforma, a MERCATÓRIO poderá:
        <ol style={{ listStyleType: "none" }}>
          <li>
            (a) Apresentar aos Investidores oportunidades de investimento em
            debêntures emitidas em operações estruturadas pela MERCATÓRIO,
            formalizadas por meio de Boletim de Subscrição de Debêntures.
          </li>
          <li>
            (b) O Investidor cadastrado na Plataforma terá acesso às informações
            e documentos relativos às debêntures ofertadas e poderá
            subscrevê-las, desde que cumpra os requisitos estabelecidos nestes
            Termos de Uso, no Boletim de Subscrição de Debêntures e na Lâmina do
            Investimento, quando aplicável.
          </li>
        </ol>
      </span>
      <p>
        1.5. A MERCATÓRIO reserva-se o direito de alterar estes Termos de Uso a
        qualquer tempo, mediante comunicação aos Usuários, conforme procedimento
        estabelecido na cláusula 13.
      </p>

      <h6>2. OPERAÇÕES</h6>
      <span>
        2.1. A estruturação das operações de emissão e distribuição das
        debêntures ocorrerá da seguinte forma:
        <ol style={{ listStyleType: "none" }}>
          <li>
            (1) Estruturação da operação de emissão das debêntures pela
            MERCATÓRIO;
          </li>
          <li>(2) Disponibilização das debêntures na Plataforma;</li>
          <li>
            (3) Formalização da subscrição das debêntures pelos Investidores,
            mediante assinatura do Boletim de Subscrição de Debêntures.
          </li>
        </ol>
      </span>
      <p>
        2.2. O investimento será realizado por meio de pagamento de boleto
        bancário ou transferência via PIX. Cada Boletim de Subscrição de
        Debêntures representa um valor mobiliário individual do Investidor.
      </p>
      <p>
        2.3. Cada Boletim de Subscrição de Debêntures formalizado pela
        MERCATÓRIO constitui um negócio jurídico autônomo, regido por termos e
        condições específicos, previstos no próprio Boletim de Subscrição de
        Debêntures e nos Documentos da Transação.
      </p>
      <span>
        2.4. A MERCATÓRIO não realiza operações de empréstimo. Sua atuação se
        limita a:
        <ol style={{ listStyleType: "none" }}>
          <li>
            (i) Adquirir os Direitos de Crédito diretamente de seus titulares.
          </li>
          <li>
            (i) Servir como Plataforma que possibilita a distribuição de
            debêntures privadas.
          </li>
          <li>
            (ii) Estruturação, monitoramento e gestão das debêntures emitidas.
          </li>
        </ol>
      </span>
      <p>
        2.5. A MERCATÓRIO não presta consultoria ou aconselhamento financeiro,
        sendo que nenhuma informação disponibilizada na Plataforma deve ser
        interpretada como recomendação de investimento.
      </p>
      <p>
        2.6. Os conteúdos e materiais disponibilizados na Plataforma têm caráter
        meramente informativo e não constituem orientação financeira ou
        jurídica, assessoria para tomada de decisões ou recomendação de
        investimento.
      </p>
      <p>
        2.7. A MERCATÓRIO não atua como consultora, assessora ou gestora de
        negócios dos Usuários, não existindo qualquer relação de consumo entre a
        MERCATÓRIO e os Usuários. Recomenda-se que os Investidores busquem
        assessoria profissional especializada para análise das oportunidades de
        investimento disponibilizadas na Plataforma.
      </p>

      <h6>3. INVESTIMENTOS E INVESTIDORES</h6>
      <p>
        3.1. As oportunidades de investimento em debêntures disponibilizadas na
        Plataforma são consideradas ofertas privadas de investimento,
        automaticamente dispensadas de registro perante a CVM.
      </p>
      <span>
        3.2. Para ser considerado um investidor apto a utilizar a Plataforma, o
        Usuário deverá atender aos seguintes critérios:
        <ol style={{ listStyleType: "none" }}>
          <li>
            (i) Ser pessoa física maior de 18 anos, residente e domiciliada no
            Brasil e possuir inscrição no Cadastro de Pessoas Físicas (CPF);
          </li>
          <li>
            (ii) Disponibilizar os dados de uma conta bancária de sua
            titularidade no Brasil para movimentação de recursos relacionados à
            Plataforma;
          </li>
          <li>
            (iii) Atender aos critérios de prevenção à fraude e lavagem de
            dinheiro definidos pela MERCATÓRIO;
          </li>
          <li>
            (iv) Preencher o Questionário de Perfil de Risco do investidor
            (suitability) e possuir um perfil compatível com o nível de risco
            inerente ao investimento a ser realizado, ou reconhecer
            expressamente que compreende os riscos do negócio e que opta por
            realizar investimento desalinhado com seu perfil.
          </li>
        </ol>
      </span>
      <p>
        3.3. Como parte do processo de cadastro na Plataforma, a MERCATÓRIO
        realizará a verificação da identidade do Usuário e das pessoas
        autorizadas a representá-lo, bem como procedimentos antifraude e de
        prevenção à lavagem de dinheiro, utilizando informações de agências de
        referência de crédito, empresas parceiras e ferramentas desenvolvidas
        pela MERCATÓRIO. O Usuário compromete-se a fornecer toda documentação e
        informações adicionais solicitadas pela MERCATÓRIO.
      </p>
      <p>
        3.4. O Usuário declara e garante que todas as informações fornecidas no
        curso do processo de cadastro e investimento são válidas, verdadeiras e
        precisas e que as manterá atualizadas. O Usuário garante que os
        documentos digitais disponibilizados são cópias fiéis dos originais. O
        Usuário declara, ainda, que os recursos aportados na Plataforma têm
        origem lícita, isentando a MERCATÓRIO de qualquer responsabilidade por
        eventual infração ou crime associado à lavagem de dinheiro ou
        financiamento ao terrorismo.
      </p>
      <p>
        3.5. A MERCATÓRIO possui discricionariedade para avaliar os pedidos de
        cadastro e poderá suspender ou limitar a atividade de qualquer Usuário
        na Plataforma, a qualquer momento, com o objetivo de cumprir suas
        obrigações legais e políticas internas.
      </p>
      <p>
        3.6. Ao se cadastrar na Plataforma e/ou realizar um investimento, o
        Usuário declara estar ciente de que suas informações serão coletadas,
        utilizadas e armazenadas pela MERCATÓRIO, nos termos da Política de
        Privacidade.
      </p>
      <p>
        3.7. Ao se cadastrar, o Usuário deverá fornecer um endereço de e-mail,
        um telefone válido e senha pessoal, que deverão ser utilizados para
        acesso às áreas restritas da Plataforma. O Usuário é o único responsável
        pela confidencialidade de sua senha.
      </p>
      <p>
        3.8. O Usuário é responsável por todas as atividades realizadas na
        Plataforma sob seu nome de usuário e senha. Qualquer violação de
        segurança, perda, roubo ou uso não autorizado de nome de usuário, senha
        ou informações de segurança deverá ser notificado imediatamente à
        MERCATÓRIO pelo e-mail: contato@mercatorio.com.br.
      </p>
      <p>
        3.9. Antes de realizar qualquer investimento por meio da Plataforma, o
        Usuário deverá responder ao Questionário de Perfil de Risco e selecionar
        sua qualificação como investidor (comum, qualificado ou profissional).
      </p>

      <h6>4. COMO REALIZAR UM INVESTIMENTO</h6>
      <span>
        4.1. Para realizar um investimento, o Usuário deverá seguir as seguintes
        etapas:
        <ol style={{ listStyleType: "none" }}>
          <li>
            (i) Registrar-se na Plataforma, preenchendo todos os dados
            solicitados e criando uma senha;
          </li>
          <li>
            (ii) Receber e clicar no link de confirmação enviado por e-mail e
            por telefone para validar o cadastro;
          </li>
          <li>
            (iii) Analisar as oportunidades de investimento disponíveis,
            preencher o Questionário de Perfil de Risco e fornecer documentos
            para verificação de perfil;
          </li>
          <li>
            (iv) Após a conclusão das etapas anteriores, o Usuário será
            considerado um potencial investidor ativo e poderá participar de uma
            subscrição de debêntures, formalizada por meio do Boletim de
            Subscrição de Debêntures;
          </li>
          <li>
            (v) Antes de realizar um investimento, o Usuário deverá analisar
            cuidadosamente todas as informações referentes à oportunidade,
            incluindo cronograma de pagamentos, retorno esperado, riscos,
            mitigantes e cenários macroeconômicos. A MERCATÓRIO disponibiliza as
            informações de maneira organizada e transparente, mas não presta
            consultoria ou recomendação de investimento;
          </li>
          <li>
            (vi) Cada oportunidade de investimento ficará aberta na Plataforma
            por um período indeterminado. Ao escolher uma das opções, o Usuário
            poderá confirmar seu interesse em investir, informar o valor
            desejado e assinar o Boletim de Subscrição de Debêntures e o
            presente Termo de Adesão, seguindo as instruções da Plataforma. Em
            seguida, será disponibilizado um boleto bancário ou QR Code Pix para
            pagamento;
          </li>
          <li>
            (vii) O montante investido será direcionado para a conta corrente da
            MERCATÓRIO;
          </li>
          <li>
            (viii) A transferência de recursos e o investimento serão
            formalizados mediante a assinatura dos Contratos de Subscrição de
            Debêntures;
          </li>
        </ol>
      </span>
      <p>
        4.2. A MERCATÓRIO realiza uma análise prévia das debêntures oferecidas
        na Plataforma, mas é de responsabilidade do Investidor realizar sua
        própria investigação, análise e avaliação da oportunidade de
        investimento, buscando aconselhamento financeiro e jurídico
        independente, quando necessário.
      </p>
      <p>
        4.3. A MERCATÓRIO reserva-se o direito de não divulgar os critérios
        utilizados para a classificação de risco de cada debênture ofertada na
        Plataforma. Essa classificação pode variar no tempo e ser revista a cada
        nova emissão.
      </p>

      <h6>5. REMUNERAÇÃO E RECEBIMENTO</h6>
      <p>
        5.1. Os pagamentos devidos aos Investidores, nos termos do Boletim de
        Subscrição de Debêntures, poderão ser visualizados na conta do
        investidor na Plataforma, sendo que, sobre esses valores, serão
        deduzidos os tributos aplicáveis, quando for o caso.
      </p>
      <p>
        5.2. O retorno dos investimentos realizados por meio da Plataforma está
        condicionado ao fluxo de caixa gerado pela operação subjacente de compra
        e recebimento dos precatórios e ao cumprimento do cronograma de
        pagamento estabelecido na Lâmina de Investimento e/ou Boletim de
        Subscrição.
      </p>
      <p>
        5.3. O Investidor receberá os pagamentos referentes ao principal e aos
        juros diretamente em sua conta corrente, no prazo de até dois dias
        úteis, contados da data em que comunicar sua opção pelo recebimento dos
        recursos, em vez da revolvência.
      </p>
      <p>
        5.4. Na hipótese de atraso no pagamento por parte da devedora das
        debêntures, serão aplicados os encargos moratórios previstos no Boletim
        de Subscrição de Debêntures.
      </p>
      <p>
        5.5. A MERCATÓRIO será responsável pela retenção do imposto de renda na
        fonte, conforme a tabela regressiva aplicável aos investimentos em renda
        fixa. Ainda assim, é responsabilidade do Investidor verificar a correta
        declaração dos rendimentos auferidos. A MERCATÓRIO enviará as instruções
        para a declaração do investimento e o informe de rendimentos anual,
        sendo o Investidor o único responsável por todos os demais custos
        relacionados ao investimento.
      </p>

      <h6>6. RISCOS</h6>
      <p>
        6.1. Os investimentos realizados por meio da Plataforma estão sujeitos
        ao risco de perda total ou parcial dos valores investidos, bem como a
        atrasos no pagamento. O Investidor deve estar ciente dos riscos
        envolvidos antes de realizar qualquer investimento.
      </p>
      <span>
        6.2. Os riscos incluem, mas não se limitam, aos seguintes:
        <ol style={{ listStyleType: "none" }}>
          <li>
            <b>(i) Fraude:</b> O cedente do Precatório pode cometer fraude ou
            realizar mais de uma cessão referente a um mesmo Precatório.
          </li>
          <li>
            <b>(ii) Dívida:</b> O cedente poderá ter dívidas particulares que
            atinjam o crédito do Precatório.
          </li>
          <li>
            <b>(iii) Dívida Alteração de Cálculo:</b> A forma de cálculo e
            atualização monetária do Precatório poderá ser alterada pelos
            tribunais (em especial, Supremo Tribunal Federal – STF e Supremo
            Tribunal de Justiça – STJ) ou por alteração legislativa. Isso
            influencia os ganhos do Precatório.
          </li>
          <li>
            <b>(iv) Demora da Liquidação:</b> Embora o Ente Federativo Devedor
            esteja obrigado a pagar suas dívidas e a requisição de pagamento já
            conste dos autos do processo que originou o Precatório, eventuais
            recursos ou atos judiciais podem retardar a liquidação do
            Precatório.
          </li>
          <li>
            <b>(v) Erros Judiciais:</b> Erros do Poder Judiciário, apesar de
            pouco comuns, podem acontecer e revelar a necessidade de uma
            rediscussão do Precatório, seja por sua existência/ inexistência ou
            seu valor, o que pode tanto afetar o Precatório quanto a demora de
            sua Liquidação.
          </li>
          <li>
            <b>(vi) Risco de Liquidez:</b> As debêntures podem não ter um
            mercado secundário ativo, o que poderá dificultar a sua venda antes
            do vencimento.
          </li>
          <li>
            <b>(vii) Risco Operacional:</b> Falhas operacionais na gestão da
            operação podem afetar o fluxo de caixa e o cumprimento do cronograma
            de pagamentos.
          </li>
        </ol>
      </span>
      <p>
        6.3. A MERCATÓRIO recomenda que o Investidor busque a assessoria de um
        consultor financeiro/jurídico e obtenha todas as informações relevantes
        antes de realizar um investimento.
      </p>
      <p>
        6.4. Cada oportunidade de investimento poderá apresentar riscos
        específicos, sendo recomendável a leitura atenta da Lâmina de
        Investimento, do Boletim de Subscrição de Debêntures e dos respectivos
        anexos.
      </p>

      <h6>7. EXTINÇÃO DE CADASTRO</h6>
      <p>
        7.1. Caso o Usuário não deseje mais manter seu cadastro na Plataforma,
        desde que não haja investimentos em vigor, poderá cancelar sua conta
        diretamente na Plataforma ou comunicar sua intenção à MERCATÓRIO por
        e-mail, sendo o cancelamento efetivado em até cinco dias úteis após o
        recebimento da solicitação.
      </p>
      <p>
        7.2. A MERCATÓRIO poderá cancelar o cadastro e excluir o Usuário da
        Plataforma em caso de descumprimento ou violação destes Termos de Uso,
        suspeita de fraude, envolvimento em lavagem de dinheiro ou outras
        atividades criminosas.
      </p>
      <p>
        7.3. Nesses casos, a MERCATÓRIO manterá em seus arquivos as informações
        do Usuário que devam ser armazenadas para cumprimento das obrigações
        legais.
      </p>

      <h6>8. CLÁUSULA MANDATO</h6>
      <p>
        8.1. O Usuário, neste ato, nomeia a MERCATÓRIO como sua bastante
        procuradora, com poderes especiais para, em seu nome e por sua conta,
        requerer, solicitar e implementar todas as etapas necessárias para
        viabilizar os investimentos por meio da Plataforma, incluindo a
        assinatura de documentos, a emissão de notificações, a contratação de
        prestadores de serviços de cobrança e escritórios de advocacia, a
        representação em processos judiciais, a transação e negociação com os
        devedores, e a outorga de substabelecimento, no todo ou em parte, dos
        poderes conferidos neste mandato.
      </p>

      <h6>9. DECLARAÇÃO E RECONHECIMENTO DO INVESTIDOR</h6>
      <span>
        9.1. Ao aceitar estes Termos de Uso, o Usuário declara:
        <ol style={{ listStyleType: "none" }}>
          <li>
            (i) Possuir plena capacidade para contratar e formalizar operações
            na Plataforma;
          </li>
          <li>
            (ii) Reconhecer a validade do Boletim de Subscrição de debêntures e
            outros títulos e valores mobiliários realizados na Plataforma;
          </li>
          <li>
            (iii) Autorizar a MERCATÓRIO a compartilhar seus dados cadastrais e
            do investimento com instituições financeiras, devedores e terceiros,
            a fim de formalizar o investimento e desenvolver suas soluções e
            serviços, nos termos da Política de Privacidade;
          </li>
          <li>
            (iv) Ser responsável perante a MERCATÓRIO por qualquer perda ou dano
            decorrente da violação destes Termos de Uso ou de qualquer uso
            fraudulento da Plataforma, incluindo o preenchimento inadequado do
            formulário de adequação de perfil de risco.
          </li>
        </ol>
      </span>

      <h6>
        10. REINVESTIMENTO E RESGATE DE RECURSOS EM CASO DE PAGAMENTO DO
        PRECATÓRIO
      </h6>
      <p>
        10.1. Em caso de pagamento integral do precatório que lastreia a
        debênture na qual o Usuário investiu, o Usuário terá a opção de:{" "}
        <b>(i)</b> reinvestir o valor proporcional da sua subscrição em uma nova
        garantia oferecida pela Mercatório, ou <b>(ii)</b> resgatar o valor
        proporcional de sua subscrição. A formalização desta escolha se dará por
        meio do Termo de Opção de Reinvestimento/Resgate de Recursos.
      </p>
      <p>
        10.2. O Termo de Opção de Reinvestimento/Resgate de Recursos é parte
        integrante do Boletim de Subscrição da Debênture e detalha as condições,
        os prazos e as consequências de cada opção. O referido termo será
        disponibilizado ao Usuário na Plataforma e enviado por e-mail, logo após
        o pagamento do(s) precatório(s) que lastreia(m) a sua debênture.
      </p>
      <p>
        10.3. Para optar pelo resgate do valor proporcional da sua subscrição, o
        Usuário deverá <i>manifestar expressamente</i> esta opção na Plataforma
        dentro do prazo de 10 (dez) dias úteis, contados do recebimento do
        e-mail de comunicação do pagamento do precatório. A manifestação deverá
        ser realizada por meio da seleção da opção de resgate na Plataforma, nos
        termos do Termo de Opção de Reinvestimento/Resgate de Recursos.
      </p>
      <p>
        10.4. Em caso de silêncio ou ausência de manifestação expressa dentro do
        prazo de 10 (dez) dias úteis, o Usuário concorda e reconhece que sua
        opção será automaticamente considerada como sendo o reinvestimento do
        valor proporcional da sua subscrição em uma nova garantia a ser
        oferecida pela Mercatório. Essa aceitação tácita do reinvestimento é uma
        condição essencial para participação nas oportunidades de investimento
        oferecidas pela Plataforma, sendo indispensável a leitura atenta das
        condições do Termo de Opção de Reinvestimento/Resgate.
      </p>
      <p>
        10.5. Na hipótese de o Usuário optar pelo reinvestimento, a Mercatório
        se compromete a buscar e substituir a garantia da debênture em até 20
        (vinte) dias úteis, contados da data do pagamento do precatório. Caso
        não seja possível realizar a substituição da garantia dentro deste
        prazo, o valor proporcional da subscrição do Usuário será integralmente
        e compulsoriamente devolvido em até 5 (cinco) dias úteis após o término
        do prazo de substituição da garantia.
      </p>
      <p>
        10.6. Em caso de opção pelo resgate, o pagamento será efetuado em até 5
        (cinco) dias úteis, contados da data da manifestação expressa do Usuário
        na Plataforma, por meio de transferência bancária para a conta corrente
        de titularidade do Usuário indicada no Boletim de Subscrição da
        Debênture.
      </p>
      <p>
        10.7. O resgate do valor proporcional da subscrição será total, não
        sendo admitido resgate parcial.
      </p>
      <p>
        10.8. O Usuário reconhece que a leitura, compreensão e concordância com
        os termos do Termo de Opção de Reinvestimento/Resgate de Recursos são
        condições essenciais para participar das oportunidades de investimento
        oferecidas na Plataforma. O silêncio ou a omissão em manifestar o
        interesse no resgate dos recursos no prazo definido acarretará na
        renovação automática do investimento, nos termos deste Termo de Uso.
      </p>
      <p>
        10.9. Para qualquer consulta ou dúvida referente ao Termo de Opção de
        Reinvestimento/Resgate, o Usuário deverá utilizar os canais de contato
        disponibilizados pela Mercatório, conforme especificado na cláusula
        "Contato Mercatório" destes Termos de Uso.
      </p>

      <h6>11. DISPOSIÇÕES GERAIS</h6>
      <p>
        11.1. O conteúdo e o material disponível na Plataforma têm caráter
        meramente informativo e não devem ser considerados como oferta,
        solicitação, convite, aconselhamento ou recomendação para realização de
        investimento ou qualquer outra transação financeira. Em caso de dúvida,
        o Usuário deverá buscar orientação de um consultor financeiro
        independente.
      </p>
      <p>
        11.2. O Usuário é o único responsável pelos custos decorrentes do acesso
        à Plataforma e declara ter ciência de que a sua utilização ocorre por
        sua conta e risco.
      </p>
      <p>
        11.3. A Plataforma pode conter links para sites de terceiros, sendo que
        a MERCATÓRIO não se responsabiliza por qualquer material fornecido ou
        contido em tais sites.
      </p>
      <p>
        11.4. A nulidade ou invalidade de qualquer disposição destes Termos de
        Uso não prejudicará a validade e eficácia das demais cláusulas.
      </p>
      <p>
        11.5. A MERCATÓRIO poderá, a seu exclusivo critério, transigir,
        renunciar ou adiar o exercício de qualquer direito previsto nestes
        Termos de Uso, sem que isso implique em prejuízo aos demais direitos.
      </p>
      <p>
        11.6. O não exercício, por qualquer das partes, ou o atraso no exercício
        de qualquer direito assegurado por este instrumento não constituirá
        renúncia ou novação de tal direito.
      </p>
      <p>
        11.7. A MERCATÓRIO poderá ceder ou transferir quaisquer de seus direitos
        ao abrigo destes Termos de Uso, independentemente da aprovação do
        investidor.
      </p>
      <p>
        11.8. Estes Termos de Uso são regidos e interpretados de acordo com as
        leis da República Federativa do Brasil.
      </p>
      <p>
        11.9. Qualquer disputa ou controvérsia decorrente destes Termos de Uso
        será resolvida por meio de arbitragem perante a Câmara de Arbitragem e
        Mediação Empresarial - Brasil (CAMARB), conforme o regulamento da CAMARB
        em vigor na data do pedido de instauração da arbitragem.
      </p>
      <p>
        11.10. A arbitragem será conduzida por três árbitros, sendo um nomeado
        pelo requerente e outro pelo requerido, conforme o Regulamento da
        CAMARB.
      </p>
      <p>
        11.11. Cada parte arcará com os custos e despesas a que der causa no
        decorrer da arbitragem, sendo as despesas comuns rateadas em partes
        iguais. A sentença arbitral definirá a responsabilidade final pelo custo
        do processo.
      </p>
      <p>
        11.12. Fica eleito o foro central da cidade de Belo Horizonte, Estado de
        Minas Gerais, para os fins exclusivos de assegurar a instituição da
        arbitragem e obter medidas urgentes para proteção ou salvaguarda de
        direitos.
      </p>
      <p>11.13. O Tribunal Arbitral não poderá julgar por equidade.</p>

      <h6>12. DIREITOS DE PROPRIEDADE INTELECTUAL</h6>
      <p>
        12.1. A MERCATÓRIO é detentora de todos os direitos autorais, marcas
        registradas, direitos de design, direitos de banco de dados e outros
        direitos de propriedade intelectual relativos à Plataforma.
      </p>
      <p>
        12.2. O Usuário concorda em autorizar a MERCATÓRIO a utilizar e veicular
        qualquer propriedade intelectual de sua titularidade que venha a ser
        veiculada na Plataforma.
      </p>
      <p>
        12.3. O Usuário concede à MERCATÓRIO o direito exclusivo, livre de
        royalties e por prazo indeterminado, para usar, copiar, distribuir,
        publicar e transmitir a terceiros os dados submetidos à Plataforma, nos
        termos da Política de Privacidade.
      </p>
      <p>
        12.4. A MERCATÓRIO compromete-se a envidar seus melhores esforços para
        garantir a segurança dos dados disponibilizados.
      </p>

      <h6>13. CONTATO MERCATÓRIO</h6>
      <p>
        13.1. Em caso de dúvidas ou para entrar em contato com a MERCATÓRIO, o
        Usuário poderá utilizar o site da MERCATÓRIO
        (https://www.mercatorio.com.br) ou o e-mail: contato@mercatorio.com.br.
      </p>
      <p>
        13.2. Reclamações formais deverão ser encaminhadas por escrito para o
        e-mail: contato@mercatorio.com.br ou pelo telefone +55 (31) 3181-0270.
      </p>

      <h6>14. ALTERAÇÕES DESTES TERMOS E CONDIÇÕES</h6>
      <p>
        14.1. A MERCATÓRIO reserva-se o direito de atualizar estes Termos de Uso
        sempre que necessário, sendo responsável por informar o Usuário acerca
        de qualquer atualização. As alterações não afetarão as operações já
        realizadas até o momento da atualização. A continuidade do uso da
        Plataforma após eventuais alterações implica na aceitação dos Termos de
        Uso atualizados. Caso o Usuário não concorde com as alterações, poderá
        solicitar o cancelamento de seu cadastro.
      </p>

      <p>
        <b>Data da Última Atualização: 31/01/2025.</b>
      </p>
    </>
  );
};
